export default {"src":"/_next/static/media/sparkles.4f2f6df0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};